// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"f5dc2c62","745":"19feb1ab","787":"6c9b663c"}[chunkId] + ".chunk.js";
};